import { useEffect } from 'react';

export const useOnVisible = (callback: () => void, deps?: Array<any>) => {
  useEffect(() => {
    const handler = () => {
      if (!document.hidden) {
        callback();
      }
    };

    window.addEventListener('visibilitychange', handler);
    return () => window.removeEventListener('visibilitychange', handler);
  }, deps || []);
};
